import React from 'react';
import SkeletonElement from 'Components/GMS/Category/Shimmer/SkeletonElement';
import { useConfigurationContext } from './Context/ConfigurationContext';
import { MappingTable } from './MappingTable';
import TooltipOverlay from 'Components/Common/components/Button/TooltipOverlay';
import TooltipInfo from 'Components/Common/components/TooltipInfo';
import { InfoIcon, TooltipIcons } from 'assests/GmsIcons';

type ProductsTabProps = {
  id?: string;
};

export const ProductsTab = ({ id = 'products-tab' }: ProductsTabProps) => {
  const { currentConfig, isLoading } = useConfigurationContext();

  if (isLoading) {
    return (
      <div data-testid={`${id}-loading`}>
        <div
          className="tw-space-y-2"
          data-testid={`${id}-skeleton-container`}
        >
          {[0, 1, 2, 3, 4].map((index) => (
            <SkeletonElement
              key={index}
              type="title"
              data-testid={`${id}-skeleton-${index}`}
            />
          ))}
        </div>
      </div>
    );
  }

  if (!currentConfig?.product) return null;

  return (
    <div data-testid={id}>
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
        <span className="tw-text-slate-500 tw-text-sm tw-font-semibold">Mapping</span>
        <TooltipOverlay message={'Product feed mapping must be configured in the Configuration Panel'}>
          <InfoIcon />
        </TooltipOverlay>
      </div>
      <MappingTable
        id={`${id}-mapping-table`}
        mappings={currentConfig.product}
      />
    </div>
  );
};